/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocialHistoryResponseDto
 */
export interface SocialHistoryResponseDto {
    /**
     * Unique identifier for the patient's social history record.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    id: string;
    /**
     * Patient identity
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    patientId: string;
    /**
     * Patient's current relationship status (e.g., Single, Married, Partnered, etc.).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    relationship: SocialHistoryResponseDtoRelationshipEnum;
    /**
     * Indicates if the patient has children.
     * @type {boolean}
     * @memberof SocialHistoryResponseDto
     */
    hasChildren: boolean;
    /**
     * Number of children the patient has.
     * @type {number}
     * @memberof SocialHistoryResponseDto
     */
    numberOfChildren: number;
    /**
     * Age of children the patient has.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    agesOfChildren: string;
    /**
     * Patient's tobacco use status (Never, Former, Current).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    tobaccoUse: SocialHistoryResponseDtoTobaccoUseEnum;
    /**
     * Patient's tobacco use amount.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    tobaccoUseAmount: string;
    /**
     * Patient's alcohol use frequency (Never, Occasionally, Weekly, Daily).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    alcoholUse: SocialHistoryResponseDtoAlcoholUseEnum;
    /**
     * Patient's alcohol use amount.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    alcoholUseAmount: string;
    /**
     * Indicates if the patient uses cannabis or other drugs.
     * @type {boolean}
     * @memberof SocialHistoryResponseDto
     */
    cannabisOrDrugUse: boolean;
    /**
     * Patient's cannabis or drug use amount.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    cannabisOrDrugUseAmount: string;
    /**
     * Patient's caffeine consumption (None, 1-2 cups/day, 3+ cups per day).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    caffeineUse: SocialHistoryResponseDtoCaffeineUseEnum;
    /**
     * Patient's caffeine source.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    caffeineSource: string;
    /**
     * Average number of hours the patient sleeps per night.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    sleepHours: SocialHistoryResponseDtoSleepHoursEnum;
    /**
     * Patient's self-reported sleep quality (Poor, Fair, Good).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    sleepQuality: SocialHistoryResponseDtoSleepQualityEnum;
    /**
     * Indicates if the patient has trouble sleeping.
     * @type {boolean}
     * @memberof SocialHistoryResponseDto
     */
    sleepTrouble: boolean;
    /**
     * Number of times per week the patient engages in physical activity.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    physicalActivityFrequency: SocialHistoryResponseDtoPhysicalActivityFrequencyEnum;
    /**
     * Type of physical activity the patient participates in (e.g., running, swimming).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    physicalActivityType: string;
    /**
     * Average duration (in minutes) of each physical activity session.
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    physicalActivityMinutesPerSession: string;
    /**
     * Patient's perceived stress level (Low, Moderate, High).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    stressLevel: SocialHistoryResponseDtoStressLevelEnum;
    /**
     * Patient's relationship stresses (None, Family, Romantic, Business, Friends).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    relationshipStresses: SocialHistoryResponseDtoRelationshipStressesEnum;
    /**
     * Primary sources of stress for the patient (e.g., work, family).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    stressSource: string;
    /**
     * Methods the patient uses to cope with stress (e.g., exercise, meditation).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    stressCopingMethods: string;
    /**
     * Indicates if the patient has a support system (e.g., friends, family).
     * @type {boolean}
     * @memberof SocialHistoryResponseDto
     */
    hasSupportSystem: boolean;
    /**
     * Additional note about the patient's social history (e.g., allergies, chronic conditions).
     * @type {string}
     * @memberof SocialHistoryResponseDto
     */
    additionalInformation?: string;
}


/**
 * @export
 */
export const SocialHistoryResponseDtoRelationshipEnum = {
    Single: 'Single',
    Married: 'Married',
    Partnered: 'Partnered',
    Divorced: 'Divorced',
    Widowed: 'Widowed'
} as const;
export type SocialHistoryResponseDtoRelationshipEnum = typeof SocialHistoryResponseDtoRelationshipEnum[keyof typeof SocialHistoryResponseDtoRelationshipEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoTobaccoUseEnum = {
    Never: 'Never',
    Former: 'Former',
    Current: 'Current'
} as const;
export type SocialHistoryResponseDtoTobaccoUseEnum = typeof SocialHistoryResponseDtoTobaccoUseEnum[keyof typeof SocialHistoryResponseDtoTobaccoUseEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoAlcoholUseEnum = {
    Never: 'Never',
    Occasionally: 'Occasionally',
    Weekly: 'Weekly',
    Daily: 'Daily'
} as const;
export type SocialHistoryResponseDtoAlcoholUseEnum = typeof SocialHistoryResponseDtoAlcoholUseEnum[keyof typeof SocialHistoryResponseDtoAlcoholUseEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoCaffeineUseEnum = {
    None: 'None',
    _12CupsDay: '1-2 cups/day',
    _3CupsPerDay: '3+ cups per day'
} as const;
export type SocialHistoryResponseDtoCaffeineUseEnum = typeof SocialHistoryResponseDtoCaffeineUseEnum[keyof typeof SocialHistoryResponseDtoCaffeineUseEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoSleepHoursEnum = {
    _12HoursNight: '1-2 hours/night',
    _34HoursNight: '3-4 hours/night',
    _56HoursNight: '5-6 hours/night',
    _78HoursNight: '7-8 hours/night',
    _910HoursNight: '9-10 hours/night',
    _1112HoursNight: '11-12 hours/night'
} as const;
export type SocialHistoryResponseDtoSleepHoursEnum = typeof SocialHistoryResponseDtoSleepHoursEnum[keyof typeof SocialHistoryResponseDtoSleepHoursEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoSleepQualityEnum = {
    Poor: 'Poor',
    Fair: 'Fair',
    Good: 'Good'
} as const;
export type SocialHistoryResponseDtoSleepQualityEnum = typeof SocialHistoryResponseDtoSleepQualityEnum[keyof typeof SocialHistoryResponseDtoSleepQualityEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoPhysicalActivityFrequencyEnum = {
    _12DaysWeek: '1-2 days/week',
    _23DaysWeek: '2-3 days/week',
    _34DaysWeek: '3-4 days/week',
    _45DaysWeek: '4-5 days/week',
    _5DaysWeek: '5+ days/week'
} as const;
export type SocialHistoryResponseDtoPhysicalActivityFrequencyEnum = typeof SocialHistoryResponseDtoPhysicalActivityFrequencyEnum[keyof typeof SocialHistoryResponseDtoPhysicalActivityFrequencyEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoStressLevelEnum = {
    Low: 'Low',
    Moderate: 'Moderate',
    High: 'High'
} as const;
export type SocialHistoryResponseDtoStressLevelEnum = typeof SocialHistoryResponseDtoStressLevelEnum[keyof typeof SocialHistoryResponseDtoStressLevelEnum];

/**
 * @export
 */
export const SocialHistoryResponseDtoRelationshipStressesEnum = {
    None: 'None',
    Family: 'Family',
    Romantic: 'Romantic',
    Business: 'Business',
    Friends: 'Friends'
} as const;
export type SocialHistoryResponseDtoRelationshipStressesEnum = typeof SocialHistoryResponseDtoRelationshipStressesEnum[keyof typeof SocialHistoryResponseDtoRelationshipStressesEnum];


/**
 * Check if a given object implements the SocialHistoryResponseDto interface.
 */
export function instanceOfSocialHistoryResponseDto(value: object): value is SocialHistoryResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('hasChildren' in value) || value['hasChildren'] === undefined) return false;
    if (!('numberOfChildren' in value) || value['numberOfChildren'] === undefined) return false;
    if (!('agesOfChildren' in value) || value['agesOfChildren'] === undefined) return false;
    if (!('tobaccoUse' in value) || value['tobaccoUse'] === undefined) return false;
    if (!('tobaccoUseAmount' in value) || value['tobaccoUseAmount'] === undefined) return false;
    if (!('alcoholUse' in value) || value['alcoholUse'] === undefined) return false;
    if (!('alcoholUseAmount' in value) || value['alcoholUseAmount'] === undefined) return false;
    if (!('cannabisOrDrugUse' in value) || value['cannabisOrDrugUse'] === undefined) return false;
    if (!('cannabisOrDrugUseAmount' in value) || value['cannabisOrDrugUseAmount'] === undefined) return false;
    if (!('caffeineUse' in value) || value['caffeineUse'] === undefined) return false;
    if (!('caffeineSource' in value) || value['caffeineSource'] === undefined) return false;
    if (!('sleepHours' in value) || value['sleepHours'] === undefined) return false;
    if (!('sleepQuality' in value) || value['sleepQuality'] === undefined) return false;
    if (!('sleepTrouble' in value) || value['sleepTrouble'] === undefined) return false;
    if (!('physicalActivityFrequency' in value) || value['physicalActivityFrequency'] === undefined) return false;
    if (!('physicalActivityType' in value) || value['physicalActivityType'] === undefined) return false;
    if (!('physicalActivityMinutesPerSession' in value) || value['physicalActivityMinutesPerSession'] === undefined) return false;
    if (!('stressLevel' in value) || value['stressLevel'] === undefined) return false;
    if (!('relationshipStresses' in value) || value['relationshipStresses'] === undefined) return false;
    if (!('stressSource' in value) || value['stressSource'] === undefined) return false;
    if (!('stressCopingMethods' in value) || value['stressCopingMethods'] === undefined) return false;
    if (!('hasSupportSystem' in value) || value['hasSupportSystem'] === undefined) return false;
    return true;
}

export function SocialHistoryResponseDtoFromJSON(json: any): SocialHistoryResponseDto {
    return SocialHistoryResponseDtoFromJSONTyped(json, false);
}

export function SocialHistoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialHistoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'relationship': json['relationship'],
        'hasChildren': json['hasChildren'],
        'numberOfChildren': json['numberOfChildren'],
        'agesOfChildren': json['agesOfChildren'],
        'tobaccoUse': json['tobaccoUse'],
        'tobaccoUseAmount': json['tobaccoUseAmount'],
        'alcoholUse': json['alcoholUse'],
        'alcoholUseAmount': json['alcoholUseAmount'],
        'cannabisOrDrugUse': json['cannabisOrDrugUse'],
        'cannabisOrDrugUseAmount': json['cannabisOrDrugUseAmount'],
        'caffeineUse': json['caffeineUse'],
        'caffeineSource': json['caffeineSource'],
        'sleepHours': json['sleepHours'],
        'sleepQuality': json['sleepQuality'],
        'sleepTrouble': json['sleepTrouble'],
        'physicalActivityFrequency': json['physicalActivityFrequency'],
        'physicalActivityType': json['physicalActivityType'],
        'physicalActivityMinutesPerSession': json['physicalActivityMinutesPerSession'],
        'stressLevel': json['stressLevel'],
        'relationshipStresses': json['relationshipStresses'],
        'stressSource': json['stressSource'],
        'stressCopingMethods': json['stressCopingMethods'],
        'hasSupportSystem': json['hasSupportSystem'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
    };
}

export function SocialHistoryResponseDtoToJSON(json: any): SocialHistoryResponseDto {
    return SocialHistoryResponseDtoToJSONTyped(json, false);
}

export function SocialHistoryResponseDtoToJSONTyped(value?: SocialHistoryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'relationship': value['relationship'],
        'hasChildren': value['hasChildren'],
        'numberOfChildren': value['numberOfChildren'],
        'agesOfChildren': value['agesOfChildren'],
        'tobaccoUse': value['tobaccoUse'],
        'tobaccoUseAmount': value['tobaccoUseAmount'],
        'alcoholUse': value['alcoholUse'],
        'alcoholUseAmount': value['alcoholUseAmount'],
        'cannabisOrDrugUse': value['cannabisOrDrugUse'],
        'cannabisOrDrugUseAmount': value['cannabisOrDrugUseAmount'],
        'caffeineUse': value['caffeineUse'],
        'caffeineSource': value['caffeineSource'],
        'sleepHours': value['sleepHours'],
        'sleepQuality': value['sleepQuality'],
        'sleepTrouble': value['sleepTrouble'],
        'physicalActivityFrequency': value['physicalActivityFrequency'],
        'physicalActivityType': value['physicalActivityType'],
        'physicalActivityMinutesPerSession': value['physicalActivityMinutesPerSession'],
        'stressLevel': value['stressLevel'],
        'relationshipStresses': value['relationshipStresses'],
        'stressSource': value['stressSource'],
        'stressCopingMethods': value['stressCopingMethods'],
        'hasSupportSystem': value['hasSupportSystem'],
        'additionalInformation': value['additionalInformation'],
    };
}

